import React, { useState } from "react";
import {
  Box,
  ButtonBase,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography
} from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import GroupsIcon from "@mui/icons-material/Groups";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { UserAvatar } from "./UserAvatar";

export function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  if (!user) return null;

  const handleClose = () => setAnchorEl(null);

  return (
    <Box>
      <ButtonBase
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-label="User menu"
        aria-controls={open ? "user-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        sx={{
          borderRadius: 2,
          px: 1,
          py: 0.5,
          gap: 1,
          display: "flex",
          alignItems: "center",
          "&:hover": { bgcolor: "action.hover" }
        }}
      >
        <UserAvatar
          displayName={user.displayName}
          avatarUrl={user.avatarUrl}
          userId={user.id}
        />
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            maxWidth: 120,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: { xs: "none", sm: "block" }
          }}
        >
          {user.displayName}
        </Typography>
      </ButtonBase>

      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { minWidth: 160, mt: 0.5 } }
        }}
      >
        {user.role === "admin" && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/admin");
            }}
          >
            <ListItemIcon>
              <AdminPanelSettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Admin</ListItemText>
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleClose();
            navigate("/settings");
          }}
        >
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={async () => {
            handleClose();
            await logout();
            navigate("/");
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Log out</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
}
